import React from 'react'
import moment from 'moment'

const WeekDaysHeader = ({ date }) => {
  return (
    <div>
      <p className="font-semibold">{moment(date).format('dddd')}</p>

      <p className="font-semibold text-xs">{moment(date).format('DD/MM')}</p>
    </div>
  )
}

export default WeekDaysHeader
